import {
  Box,
  Drawer,
  Chip,
  Stack,
  Divider,
  IconButton,
  Typography,
  Button,
} from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ImageIcon from "@mui/icons-material/Image";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import TokenIcon from "@mui/icons-material/Token";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { toggleAttachmentDrawer } from "../redux/messagesSlice";
import { openBuyGiftsDrawer } from "../redux/giftShoppingCartSlice";
import { fetchGiftBrands } from "../redux/giftBrandsSlice";
import {
  fetchNfts,
  openNftSelectionDrawer,
  fetchNftsForMarket,
} from "../redux/nftSlice";
import { addMessagePart } from "../redux/messagesSlice";

interface AttachmentDrawerProps {}

const AttachmentDrawer: React.FC<AttachmentDrawerProps> = () => {
  //const [open, setOpen] = useState(false);
  const [selectedType, setSelectedType] = useState<string | null>(null);
  //   const theme = useTheme();
  const dispatch = useAppDispatch();
  const { attachmentDrawerOpen } = useAppSelector((state) => state.messages);

  const attachmentTypes = [
    { label: "Media", icon: <ImageIcon />, value: "media" },
    { label: "Tokens", icon: <TokenIcon />, value: "tokens" },
    { label: "Gifts", icon: <CardGiftcardIcon />, value: "gifts" },
  ];

  const toggleDrawer = (isOpen: boolean) => () => {
    dispatch(toggleAttachmentDrawer());
    if (!isOpen) setSelectedType(null);
  };

  return (
    <>
      {/* Trigger button - would be placed near your message input */}
      <IconButton onClick={toggleDrawer(true)} color="primary">
        <AttachFileIcon />
      </IconButton>

      {/* The drawer component */}
      <Drawer
        anchor="bottom"
        open={attachmentDrawerOpen}
        onClose={() => dispatch(toggleAttachmentDrawer())}
        sx={{
          "& .MuiDrawer-paper": {
            width: { xs: "100%", sm: 500 },
            margin: "0 auto",
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            height: "auto",
            maxHeight: "60vh",
            boxSizing: "border-box",
            px: 2,
            pb: 2,
            pt: 1,
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography variant="subtitle1">Add Attachment</Typography>
          <IconButton onClick={toggleDrawer(false)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider sx={{ mb: 2 }} />

        <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
          {attachmentTypes.map((type) => (
            <Chip
              key={type.value}
              icon={type.icon}
              label={type.label}
              onClick={() => setSelectedType(type.value)}
              variant={selectedType === type.value ? "filled" : "outlined"}
              sx={{
                borderRadius: 4,
                px: 1.5,
                py: 2,
                fontSize: "0.875rem",
                "& .MuiChip-icon": {
                  color: selectedType === type.value ? "white" : "inherit",
                },
              }}
              color="primary"
            />
          ))}
        </Stack>

        {/* Content area that changes based on selection */}
        <Box sx={{ mt: 3, flex: 1, overflow: "auto" }}>
          {selectedType === "media" && (
            <Box>
              {/* <Typography>Media content selector</Typography> */}
              {/* Your media picker implementation */}
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                onClick={async () => {
                  // Handle gift selection logic here
                  dispatch(
                    addMessagePart({ type: "image", content: "Image URL" })
                  );
                  //console.log("Image selected");
                }}
              >
                Image
              </Button>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                onClick={async () => {
                  // Handle gift selection logic here
                  dispatch(
                    addMessagePart({ type: "video", content: "Video URL" })
                  );
                  // console.log("Image selected");
                }}
              >
                Video
              </Button>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                onClick={async () => {
                  // Handle gift selection logic here
                  console.log("Image selected");
                }}
              >
                File
              </Button>
            </Box>
          )}
          {selectedType === "tokens" && (
            <Box>
              {/* <Typography>Token selector</Typography> */}
              {/* Your token picker implementation */}
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                onClick={async () => {
                  // Handle gift selection logic here
                  // console.log("Gift selected");
                  await dispatch(fetchNftsForMarket());
                  dispatch(openNftSelectionDrawer());
                  dispatch(toggleAttachmentDrawer());
                }}
              >
                Buy Nfts
              </Button>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                onClick={async () => {
                  // Handle gift selection logic here
                  // console.log("Gift selected");
                  await dispatch(fetchNfts());
                  dispatch(openNftSelectionDrawer());
                  dispatch(toggleAttachmentDrawer());
                }}
              >
                My Nfts
              </Button>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                onClick={async () => {
                  // Handle gift selection logic here
                  // console.log("Gift selected");
                }}
              >
                Tokens
              </Button>
            </Box>
          )}
          {selectedType === "gifts" && (
            <Box>
              {/* <Typography>Gift selector</Typography> */}
              {/* Your gift picker implementation */}
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                onClick={async () => {
                  // Handle gift selection logic here
                  // console.log("Gift selected");
                  await dispatch(
                    fetchGiftBrands({ countryCode: "CA", currentPage: 1 })
                  );
                  dispatch(openBuyGiftsDrawer());
                  dispatch(toggleAttachmentDrawer());
                }}
              >
                Buy Gifts
              </Button>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                onClick={() => {
                  // Handle gift selection logic here
                  // console.log("Gift selected");
                  //   await dispatch(
                  //     fetchGiftBrands({ countryCode: "CA", currentPage: 1 })
                  //   );
                  //   dispatch(openBuyGiftsDrawer());
                  //   dispatch(toggleAttachmentDrawer());
                }}
              >
                My Gifts
              </Button>
            </Box>
          )}
        </Box>
      </Drawer>
    </>
  );
};

export default AttachmentDrawer;
